import { BASE_URL,BASE_URL_TOKEN, SYSTEM_ERROR, SOMS_API_KEY, USERS_PREVILEGE_ENDPOINT } from "./CONSTANTS";
import { Get, Post } from "./apiService";

export const GetPrivileges = (request) => {
    return new Promise((resolve, reject) => {
        try {
            // request.url = `${process.env.REACT_APP_SOMS_ROUTE53_URL}${USERS_PREVILEGE_ENDPOINT}${request.id_token}?apikey=${request.apikey}`;
            request.url = `${BASE_URL}${USERS_PREVILEGE_ENDPOINT}${request.id_token}`;

            Get(request)
                .then((res) => {
                    resolve(res);
                })
                .catch((err) => {
                    reject(err);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};


export const postToken = (request) => {
    return new Promise((resolve, reject) => {
        try {
            let encodedKey = window.btoa(SOMS_API_KEY);
            request.url = `${BASE_URL_TOKEN}?apikey=${window.atob(encodedKey)}`;

            Post(request)
                .then((res) => {
                    if (res) {
                        resolve(res.data);
                    }
                })
                .catch((errResponse) => {
                    reject(errResponse);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};
export const postTokenSession = (request) => {
    return new Promise((resolve, reject) => {
        try {
            request.url = `${BASE_URL}${USERS_PREVILEGE_ENDPOINT}${request.userId}/session?apikey=${request.apikey}`;

            request.config = {
                headers: {
                    'Content-Type': 'application/json;charset=UTF-8',
                }
            }
            Post(request)
                .then((res) => {
                    if (res) {
                        resolve(res.data);
                    }
                })
                .catch((errResponse) => {
                    reject(errResponse);
                });
        } catch (error) {
            reject(SYSTEM_ERROR);
        }
    });
};